import { Component, Input, OnInit } from '@angular/core';
import { ConnectionChangeDto } from '@bo-client/shared/models/connectionChange.dto';
import { PriceCalculationUtil } from '@bo-client/shared/services/price-calc.util';

@Component({
  selector: 'app-order-request-wizard-price-summary',
  templateUrl: './order-request-wizard-price-summary.component.html',
  styleUrl: './order-request-wizard-price-summary.component.scss'
})
export class OrderRequestWizardPriceSummaryComponent implements OnInit {
  @Input() data: ConnectionChangeDto;
  priceCalculation: {
    totalPriceNetto: number;
    totalPriceBrutto: number;
    mwstGrouped: {
      percentage: number;
      amount: number;
    }[];
  };
  ngOnInit() {
    this.priceCalculation = PriceCalculationUtil.calculatePrices(this.data.positions);
  }
}
